export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$'
} as const;

export type SupportedCurrency = keyof typeof CURRENCY_SYMBOLS;

export const DEFAULT_CURRENCY: SupportedCurrency = 'EUR';

const normalizeCode = (code?: string | null): string =>
  typeof code === 'string' ? code.toUpperCase().trim() : '';

export const resolveCurrencyCode = (
  code?: string | null
): SupportedCurrency => {
  const normalized = normalizeCode(code);
  return (normalized in CURRENCY_SYMBOLS
    ? normalized
    : DEFAULT_CURRENCY) as SupportedCurrency;
};

export const getCurrencySymbol = (code?: string | null): string =>
  CURRENCY_SYMBOLS[resolveCurrencyCode(code)];
